module.exports = __webpack_public_path__ + "img/dynamicmaschines_preview.4405f45c.webp";